export default __webpack_public_path__ + "static/media/frame-1.0958f5ef.jpg";